<app-static-pages-header [title]="title"></app-static-pages-header>
<div class="container anb">
  <div class="row justify-content-md-center">
    <div class="col-md-8">
      <h2 class="main__title">{{title}}</h2>
      <ol class="app__justify-text">
        <li>
          <h5>Gewinnspiel-Veranstalter:</h5>
          <p>
            SFA Sport GmbH („fan.at“)<br>
            Geidorfplatz 1/10; 8010 Graz<br>
            E-Mail: info@fan.at
          </p>
        </li>
        <li>
          <h5>Teilnahmeform</h5>
          <p>Online-Formular</p>
        </li>
        <li>
          <h5>Teilnahmeberechtigung</h5>
          <p>
            Die Aktion richtet sich ausschließlich an Verbraucher (im Sinn des KSchG)
            ab 18 Jahren mit Wohnsitz in Österreich, ausgenommen sind Mitarbeiter
            (und deren Angehörige) des Veranstalters, des Kooperationspartners und
            jeweils verbundener Unternehmen.
          </p>
        </li>
        <li>
          <h5>Spielablauf/Regeln</h5>
          <p>
            Der/Die Gewinner wird/werden aus allen rechtzeitig eingelangten,
            gültigen Einsendungen gezogen, persönlich verständigt und gegebenenfalls
            auf fan.at vorgestellt; zur Ausfolgung der Preise können die Kontaktdaten
            den jeweiligen Kooperationspartnern/Sponsoren weitergegeben werden.
          </p>
        </li>
        <li>
          <h5>Sonstige Bedingungen</h5>
          <p>
            Der Veranstalter behält sich vor, bestimmte Personen insb.
            wegen Manipulationsversuchen (zB durch Mehrfachteilnahmen) von der weiteren
            Teilnahme auszuschließen bzw. die Aktion jederzeit auch ohne Angabe von Gründen
            zur Gänze abzubrechen. Die Barabgeltung von Gewinnen und der Rechtsweg sind
            generell ausgeschlossen; beim Gewinner personenbezogen anfallende Steuern, Abgaben,
            Gebühren und Folgekosten trägt dieser selbst. Über das Gewinnspiel wird mit Ausnahme
            der Gewinnerverständigung keinerlei Korrespondenz geführt. Jegliche Haftung des
            Veranstalters und seiner Erfüllungsgehilfen sowie Organe wird auf Fälle groben
            Verschuldens beschränkt. Satz- und Druckfehler vorbehalten.
            Der Veranstalter weist darauf hin, dass die Firma „Apple” (Apple Inc.)
            dieses Gewinnspiel nicht unterstützt oder in dessen Umsetzung involviert ist.
          </p>
          <p>
            Mit der Annahme der Gewinnspielbedingungen nimmt der Teilnehmer zustimmend zur Kenntnis,
            dass jegliche Weitergabe der Karten an oder von nicht an fan.at (Unternehmen) und die Österr. Sportwetten
            Ges.m.b.H/tipp3 gemeldete Gewinner strikt untersagt ist und zur Ungültigerklärung der Karten führt.
            Von der Teilnahme am Gewinnspiel sind Personen ausgeschlossen, die über ein vom Österreichischen
            Fußball-Bund oder der Österreichischen Fußball-Bundesliga ausgesprochenes aufrechtes Stadionverbot verfügen.
          </p>
        </li>
        <li>
          <h5>Datenschutz</h5>
          <p>
            Der Datenverarbeitung durch den Veranstalter liegt die ausführliche Datenschutzerklärung
            von fan.at zugrunde, die unter www.fan.at/datenschutz abrufbar gehalten wird.
          </p>
        </li>
      </ol>
    </div>
  </div>
</div>
